import {Loader} from "@googlemaps/js-api-loader"
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import icon from '../../img/icon_cluster.png';

const mapElement = document.getElementById('immoMap');

if (mapElement) {
    if (mapElement.dataset.consent !== '0') {
        const btn = document.getElementById('accept-consent');
        if (btn) {
            btn.addEventListener('click', function () {
                createMap();
            })
        }
    } else {
        createMap();
    }
}

function createMap() {
    let map;

    document.querySelectorAll('.hide-without-consent').forEach(el => el.style.display = null)

    const loader = new Loader({
        apiKey: mapElement.dataset.key,
        version: 'weekly'
    });

    Promise.all([getMarkerData(), loader.load()]).then(([markerData]) => {
        map = new google.maps.Map(mapElement, {
            center: markerData.center,
            zoom: 11,
        });

        const infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });

        const markers = markerData.markers.map(({position, content}) => {
            const marker = new google.maps.Marker({position, icon: icon, label: {text: '1', color: '#fff'},});
            marker.addListener('click', () => {
                infoWindow.setContent(content)
                infoWindow.open(map, marker)
            })
            return marker
        })

        new MarkerClusterer({
            map, markers, renderer: {
                render: function ({count, position}, stats) {
                    return new google.maps.Marker({
                        position,
                        icon,
                        label: {
                            text: String(count),
                            color: '#fff'
                        },
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    })
                }
            }
        })
    })
}

async function getMarkerData() {
    const markers = [];
    let latSum = 0.0;
    let lngSum = 0.0;
    document.querySelectorAll('.marker').forEach(el => {
        const lat = parseFloat(el.dataset.lat)
        const lng = parseFloat(el.dataset.lng)
        latSum += lat;
        lngSum += lng;
        markers.push({
            content: el.outerHTML,
            position: {lat, lng}
        })
    })
    return {
        center: {
            lat: latSum / markers.length,
            lng: lngSum / markers.length,
        },
        markers,
    };
}


function createLightbox(image) {
    const lightBoxContainer = document.createElement("div");
    const lightBoxContent = document.createElement("div");
    const lightBoxImg = document.createElement("img");

    lightBoxContainer.classList.add("lightbox");
    lightBoxContent.classList.add("lightbox-content");

    lightBoxContainer.appendChild(lightBoxContent);
    lightBoxContent.appendChild(lightBoxImg);

    document.body.appendChild(lightBoxContainer);
    lightBoxContainer.style.display = "block";
    lightBoxImg.setAttribute("src", image);

    function closeLightBox() {
        if (this === event.target) {
            lightBoxContainer.style.display = "none";
        }
    }

    lightBoxContainer.addEventListener("click", closeLightBox);
}

document.addEventListener('click', function(e) {
    if (e.target.dataset.lightbox) {
        e.preventDefault();
        createLightbox(e.target.dataset.lightbox);
    }
}, false)

const lighboxes = document.querySelectorAll('.open-lightbox')
for (const lightbox of lighboxes) {
    lightbox.addEventListener('click', function(e) {
        e.preventDefault();
        createLightbox(lightbox.href);
    })
}